import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon25: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#32BBC3"
        d="M10 16a2 2 0 1 1 0 4H2a2 2 0 1 1 0-4h8Zm0 1H2a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2ZM11.84.464l3.071 3.072a1.587 1.587 0 0 1-1.832 2.542l-.887.885 7.371 7.386a1.5 1.5 0 0 1 0 2.122l-.121.122a1.5 1.5 0 0 1-2.121 0L9.949 9.206l-.886.887c.277.55.212 1.23-.194 1.72l-.103.113c-.62.62-1.624.62-2.243 0L3.45 8.854a1.586 1.586 0 0 1 1.831-2.542l4.016-4.016A1.587 1.587 0 0 1 11.84.464Zm-.355 7.207-.83.83 7.373 7.385a.5.5 0 0 0 .707 0l.122-.122a.5.5 0 0 0 0-.708l-7.372-7.385Zm-7.327-.355a.586.586 0 0 0 0 .83L7.23 11.22a.586.586 0 1 0 .829-.83L4.987 7.317a.587.587 0 0 0-.83 0Zm5.79-4.255L6.048 6.963l2.366 2.365 1.182-1.182 1.537-1.536 1.183-1.183-2.366-2.366Zm.354-1.889a.585.585 0 0 0 0 .828l3.073 3.073a.586.586 0 1 0 .83-.829l-3.072-3.072a.588.588 0 0 0-.83 0Z"
      />
    </Svg>
  )
}
